import React from 'react';
import clsx from "clsx";

interface LinkUIProps {
    href?: string;
    disabled?: boolean;
    onClick?: () => void;
    children: React.ReactNode;
    className?: string;
    title: string;
}

const LinkUI = ({ href = '#', disabled = false, onClick, children, className = '', title }: LinkUIProps) => {

    const finalClassName = clsx(
        "text-bmedium md:text-blarge",
        "underline underline-offset-2 decoration-1 transition-colors duration-300",
        disabled
            ? "text-system-light-50 cursor-not-allowed decoration-transparent pointer-events-none"
            : "text-primary-40 cursor-pointer decoration-transparent hover:decoration-primary-40",
        className
    );

    return (
        <a
            href={href}
            className={finalClassName}
            onClick={disabled ? undefined : onClick}
            title={title}
        >
            {children}
        </a>
    );
};

export default LinkUI